module.exports = __webpack_public_path__ + "1ab118f0648f7afc67cdfd844501d6dd.svg";